export const CLAUSE_LIBRARY_CHAR_DISPLAY_LIMIT = 512;
export const CLAUSE_LIBRARY_NAME_CHAR_LIMIT = 500;
export const GUIDANCE_NOTES_CHAR_LIMIT = 50000;
export const VARIATION_TEXT_CHAR_LIMIT = 50000;
